import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Logo from '../../assets/Logo3.svg';
import LinkWithArrow from '../../components/LinkWithArrow/LinkWithArrow';
import ZapierIcon from '../../assets/zapier.svg';

const sourceLogos = {
    zapier: ZapierIcon,
};

const Integration = ({
    logo_url: logoUrl,
    logo,
    title,
    description,
    source,
    flotiqDescription,
}) => (
    <div className="integration">
        <Container id="integration">
            {source && sourceLogos[source] && (
                <Row className="integration-info source">
                    <img
                        className="integration__application-header-icon"
                        src={sourceLogos[source]}
                        alt={source}
                    />
                </Row>
            )}

            <Row className="integration-info">
                <Col
                    xs={12}
                    sm={6}
                    xl={4}
                    className="integration__application flotiq"
                >
                    <h4 className="integration__application-header">
                        <img
                            className="integration__application-header-icon"
                            src={Logo}
                            alt="Flotiq"
                        />
                        Flotiq
                    </h4>
                    <p>{flotiqDescription}</p>
                </Col>
                <Col xs={12} sm={6} xl={4} className="integration__application">
                    <h4 className="integration__application-header">
                        <img
                            className="integration__application-header-icon"
                            src={logo?.[0]?.localFile?.publicURL || logoUrl}
                            alt={title}
                        />
                        {title}
                    </h4>
                    <p>{description}</p>
                </Col>
            </Row>

            <Row className="integration-info view-all">
                <Col xs={8}>
                    <LinkWithArrow
                        href="/integrations"
                        additionalClassNames={['integrations__link']}
                    >
                        View all integrations
                    </LinkWithArrow>
                </Col>
            </Row>
        </Container>
    </div>
);

export default Integration;
